import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { STORAGE_BUCKET_ORIGIN } from "../../../config/constants";
import { useParams } from "react-router-dom";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { CategoryService } from "../../../services/category-service";

export const Categoryeditcontent = (props) => {

  const [submitloading, setSubmitLoading] = useState(true);

  const { categoryId } = useParams();

  const [typeCategories, setTypeCategories] = useState([]);
  const [isVisible, setIsVisible] = useState(false);


  useEffect(() => {
    CategorySearchID();
  }, []);

  const [categoryInfo, setCategoryInfo] = useState({
    name: "",
    description: "",
    category_order: 0,
    status: "",
  });

  const CategorySearchID = async () => {
    try {
      const result = await CategoryService.categoryDetailsID(categoryId);
      const info = {};

      const categorydata = result;

      info.name = categorydata.name;
      info.category_order = categorydata.category_order;
      info.description = categorydata.description;
      info.status = categorydata.status;

      setCategoryInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  // const selectedCategorySearch = async () => {
  //   try {
  //     let result ;
  //     if(selectedOption === "sub"){
  //       const finalResult = await CategoryService.categoryWiseDetails("main");
  //       result = finalResult.results.filter((e) => e.id != categoryId)
  //     }else if(selectedOption === "level3cat"){
  //       const finalResult = await CategoryService.categoryWiseDetails("sub");
  //       result = finalResult.results.filter((e) => e.id != categoryId)
  //     }else{
  //       result = [];
  //     } 

  //     setTypeCategories(result);
  //   } catch (err) {
  //     //toast
  //     if (err.response.data.message !== undefined) {
  //       notifyWarning(err.response.data.message);
  //     } else {
  //       notifyWarning("Something Wrong");
  //     }
  //   }
  // }

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {

      //todo extra validations
      setSubmitLoading(false);

      try {
        await CategoryService.categoryUpdate(categoryId, values);

        setSubmitLoading(true);
        notify("Category successfully updated");
      } catch (err) {
        setSubmitLoading(true);
        //show error toast
        if (err.response.data.message !== undefined) {
          notifyWarning(err.response.data.message);
        } else {
          notifyWarning("Something Wrong");
        }
      }
    
  };

  // useEffect(() => {
  //   selectedCategorySearch()
  // }, [selectedOption])


  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  name: categoryInfo.name,
                  category_order: categoryInfo.category_order,
                  description: categoryInfo.description,
                  status: categoryInfo.status,
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Required")
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom18">Name</label>
                        <div className="input-group">
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            id="nameid"
                            placeholder="Name"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.name && errors.name}
                        </div>
                      </div>
                      <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom08">Description</label>
                        <div className="input-group">
                          <input
                            name="description"
                            type="text"
                            className="form-control"
                            id="descriptionId"
                            placeholder="Description"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.description && errors.description}
                        </div>
                      </div>
                    </div>
                    {/* <div className="form-row">
                      <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom18">Type</label>
                        <div className="input-group">
                          <select
                            name="type"
                            className="form-control"
                            id="typeId"
                            required
                            onChange={(e) => {
                              setFieldValue("type", e.target.value);
                              handleOptionChange(e);
                            }}
                            onBlur={handleBlur}
                            value={values.type}
                          >
                            <option value="">Select Type</option>
                            <option value="main">Main Category</option>
                            <option value="sub">Sub Category</option>
                            <option value="level3cat">Level 3 category</option>
                          
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.name && errors.name}
                        </div>
                      </div>
                      {isVisible && (<div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom08">Category</label>
                        <div className="input-group">
                        <select
                            name="categoryId"
                            className="form-control" 
                            id="categoryId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.categoryId}
                          >
                            <option value="">Select Category</option>
                            {typeCategories.map((category) => {
                              return (
                                <option key={category.id} value={category.id}>{category.name}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.categoryId && errors.categoryId}
                        </div>
                      </div>)}
                    </div> */}
                    <div className="form-row">
                    <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom08">Category Order Number</label>
                        <div className="input-group">
                          <input
                            name="category_order"
                            type="number"
                            className="form-control"
                            id="categoryOrderId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.category_order}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.category_order && errors.category_order}
                        </div>
                      </div>
                      <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom15">Status</label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DISABLED">DISABLED</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>

                    {/* <div className="form-row">
                      <label htmlFor="validationCustom08">Upload Image</label>
                      <div>
                        <img
                          alt=""
                          src={
                            uploadedFile != null
                              ? URL.createObjectURL(uploadedFile)
                              : `${STORAGE_BUCKET_ORIGIN}${maincatinfo.image}`
                          }
                          style={{
                            width: "20%",
                            marginTop: "5vh",
                            marginBottom: "1vh",
                          }}
                        />
                      </div>
                      <div className="input-group mt-2">
                        <input
                          id="maincatupload"
                          type="file"
                          name="image"
                          onBlur={handleBlur}
                          onChange={(event) => {
                            setUploadedFile(event.currentTarget.files[0]);

                            setFieldValue("image", "file");
                          }}
                        />

                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.image && errors.image}
                        </div>
                      </div>
                    </div> */}

                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>

                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Save and Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categoryeditcontent;
